/** @format */

import { paymentDeadlineCodeConstants } from './actions';
import { reducerDebug } from '../../core/debug';
import { GeoLocationStateCollectionInterface } from '../../interfaces/platform/GeoLocationStateInterface';

export type PaymentDeadLineCodeReducerType = {
    type: string;
    collections: Array<GeoLocationStateCollectionInterface>;
    selectedValue?: string;
    valueChange?: boolean;
};

export const paymentDeadlineCodeReducers = (state = {}, action: PaymentDeadLineCodeReducerType): object => {
    reducerDebug('paymentDeadlineCode reducer: ' + action.type);
    switch (action.type) {
        case paymentDeadlineCodeConstants.LIST:
        case paymentDeadlineCodeConstants.SELECT_CHANGE:
            return {
                ...state,
                ...action,
            };
        default:
            return state;
    }
};
